import { auth } from "../firebase";

// 관리자 이메일 리스트 (본인 이메일 추가)
const ADMIN_EMAILS = ["dbsgpwls416@gmail.com"];

export const isAdmin = (user) => {
  return user && ADMIN_EMAILS.includes(user.email);
};
